import script from "./NewsArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsArticle.vue?vue&type=script&setup=true&lang=ts"

import "./NewsArticle.vue?vue&type=style&index=0&id=15f805f3&lang=scss&scoped=true"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f805f3"]])

export default __exports__